// extracted by mini-css-extract-plugin
export default {"lives":"Game_lives__z6mKi","iframe":"Game_iframe__R0vo-","skeleton":"Game_skeleton__LsnR+","button":"Game_button__jS7RW","referral":"Game_referral__L0Onc"};